import React from 'react';
import ingredientsData from './nutriData.json';
import './Nutri.css';

const NutrientTable = ({ selected, ingredientsData, totals }) => {
  
  const getNutrientValue = (data, key, grams, isGI = false) => {
  if (!data?.nutrients) return 0;

  if (key === 'GI') {
    return data.nutrients?.GI || 0; // GI is not scaled
  }

  if (key === 'GL') {
    const GI = data.nutrients?.GI || 0;
    const carbs = data.nutrients?.carbohydrates || 0;
    return (GI * carbs * grams) / 10000; // GL formula
  }

  if (key.startsWith('vitamin')) {
    return data.nutrients.vitamins?.[key] || 0;
  }

  if (
    ['calcium', 'iron', 'potassium', 'magnesium', 'zinc', 'phosphorus', 'selenium'].includes(key)
  ) {
    return data.nutrients.minerals?.[key] || 0;
  }

  return data.nutrients?.[key] || 0;
};


  const renderTable = (keys, title) => (
  <div className="nutrient-section">
    <h3>{title}</h3>
    <table className="nutrient-table">
      <thead>
        <tr>
          <th>Ingredient</th>
          <th>Grams</th>
          {keys.map(key => <th key={key}>{key}</th>)}
        </tr>
      </thead>
      <tbody>
        {selected.map(({ name, grams }) => {
          const data = ingredientsData.find(i => i.name === name);
          return (
            <tr key={name}>
              <td>{name}</td>
              <td>{grams}</td>
              {keys.map(key => (
  <td key={key}>
    {key === 'GI'
      ? getNutrientValue(data, key) // GI is not scaled
      : key === 'GL'
        ? getNutrientValue(data, key, grams) // GL uses grams
        : (getNutrientValue(data, key) * grams / 100).toFixed(2)}
  </td>
))}

            </tr>
          );
        })}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={2}><strong>Total</strong></td>
          {keys.map(key => (
            <td key={key}><strong>{(totals[key] || 0).toFixed(2)}</strong></td>
          ))}
        </tr>
      </tfoot>
    </table>
  </div>
);


  return (
    <div className="nutrient-wrapper">
      <div className="nutrient-table-container">
      {renderTable(['GI', 'GL', 'calories'], 'Glycemic Index & Calories')}
      </div>
     <div>
<img src="/Images/GI.png" alt="Glycemic Index Table" width="400" height="auto" />


     </div>
     <div className="nutrient-table-container">
      {renderTable(['fat', 'fiber', 'carbohydrates', 'protein'], 'Macronutrients')}
      </div>
      <div className="nutrient-table-container">
      {renderTable(['water', 'vitaminC', 'vitaminA', 'calcium', 'iron'], 'Hydration & Core Micronutrients')}
     </div>
      <div className="nutrient-table-container">
  

      {renderTable(['potassium', 'magnesium', 'zinc', 'phosphorus', 'selenium'], 'Trace Minerals & Other Nutrients')}
    </div>

      {/* {renderTable(['potassium', 'magnesium', 'zinc', 'phosphorus', 'selenium'], 'Trace Minerals & Other Nutrients')} */}
    </div>
  );
};

export default NutrientTable;
